import { getCookie } from '../utils/CookiesUtil';
import api from "./apiMethods";

const { REACT_APP_API_URL } = process.env;

export const getTickets = async ({status}) => {

  const payload = {
    status: status,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/get-tickets-list`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
    data: payload,
  };

  return api(request);
};

export const updateTicketStatus = async (ticketId, status, commentary = '') => {
  const payload = {
    report_id: ticketId,
    status: status,
    administrator_response: commentary,
  };

  const request = {
    method: "PUT",
    url: `${REACT_APP_API_URL}/admin/update-ticket-status`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
    data: payload,
  };

  return api(request);
};

